import { render, staticRenderFns } from "./campaign-edit-wrapper.vue?vue&type=template&id=6301ba20&"
import script from "./campaign-edit-wrapper.vue?vue&type=script&lang=js&"
export * from "./campaign-edit-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports